import React from "react";
import ProjectLink from "notifications/components/project_link";

const FocusGroupLink = ({ project, focusGroup }) => {
  return (
    <ProjectLink
      project={project}
      append="focus-groups/"
      linkTitle={focusGroup.name}
    />
  );
};

export default FocusGroupLink;
